export class TorchAdminAPIKey {
  id: number;
  apiKey: string;
  createdBy: string;
  createdOn: Date;
  updatedOn: Date;
  readOnly: boolean;
  rootKey: boolean;
}
